export const currencySwitcher = (inputText) => {
  const currencyForm = JSON.parse(
    document.querySelector("#country-data").innerHTML
  );

  if (currencyForm) {
    const filteredForm = currencyForm.countries.filter((item) =>
      item.country.includes(inputText)
    );

    const options = document.querySelectorAll(".custom-select__options");

    options.forEach((optie) => {
      optie.innerHTML = "";

      filteredForm.forEach((item) => {
        const optionHTML = `<li class="disclosure__item" tabindex="-1">
      <a href="#" data-value="${item.country_iso_code}">
        <span> ${
          // item.country.charAt(0).toUpperCase() + item.country.slice(1)
          item.country
        }</span>
        <span>
          ${item.currency}
          ${item.symbol}
        </span>
      </a>
    </li>
`;

        optie.insertAdjacentHTML("beforeend", optionHTML);
      });
    });
  }

  const selectorListItem = document.querySelectorAll(".disclosure__item");
  const valueHiddenInput = document.querySelector(".js-hidden-input");
  const form = document.querySelector(".js-currency-form");

  selectorListItem.forEach((item) => {
    item.addEventListener("click", (e) => {
      const itemLink = item.querySelector("a");
      valueHiddenInput.value = itemLink.dataset.value;
      form.submit();
    });
  });
};
